import { render } from "./OrderDetail.vue?vue&type=template&id=4a79ced6&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"

import "./OrderDetail.vue?vue&type=style&index=0&id=4a79ced6&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a79ced6"]])

export default __exports__